export enum fileTypeEnum {
  excel1 = "xlsx",
  excel2 = "xls",
}
